var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 17 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.247 16.494A8.247 8.247 0 1 1 8.247 0a8.247 8.247 0 0 1 0 16.494zm.781-7.466h2.717a.778.778 0 1 0 0-1.556H9.029V4.754a.778.778 0 0 0-1.556 0v2.718H4.755a.778.778 0 1 0 0 1.556h2.717v2.718a.775.775 0 0 0 .778.778c.43 0 .778-.349.778-.779V9.028z"
})));
export default SvgAdd;